module.exports = __webpack_public_path__ + "img/logo.985308e6.png";